import React from "react";
import PopulationField from "./PopulationField"

function Population({countryAnswers}){
	return(<div className="question-grouping" id="population_economy_and_governance">
				<h2>Population, Economy, and Governance</h2>
				<div className="clearfix">
					<div className="pull-left" style={{width: "48%"}}>
						<PopulationField defaultCountry={countryAnswers.answerKeyValues["country_code"]} heading={"Population "} 
						year={countryAnswers.answerKeyValues['population_year']} 
						value={countryAnswers.answerKeyValues['population']} 
						notes={countryAnswers.answerKeyValues['population_notes']} 
						sourceRef={countryAnswers.answerKeyValues['population_sources']}/>
						<PopulationField defaultCountry={countryAnswers.answerKeyValues["country_code"]} heading={"Population Growth Rate "} 
						year={countryAnswers.answerKeyValues['population_growth_rate_year']} 
						value={countryAnswers.answerKeyValues['population_growth_rate']} 
						notes={countryAnswers.answerKeyValues['population_growth_rate_notes']} 
						sourceRef={countryAnswers.answerKeyValues['population_growth_rate_sources']} />
						<PopulationField defaultCountry={countryAnswers.answerKeyValues["country_code"]} heading={"Currency "} 
						year={countryAnswers.answerKeyValues['currency_year']} 
						value={countryAnswers.answerKeyValues['currency']} 
						notes={countryAnswers.answerKeyValues['currency_notes']} 
						sourceRef={countryAnswers.answerKeyValues['currency_sources']} />
						<PopulationField defaultCountry={countryAnswers.answerKeyValues["country_code"]} heading={"Corruption Perception Index "} 
						year={countryAnswers.answerKeyValues['corruption_perceptions_index_year']} 
						value={countryAnswers.answerKeyValues['corruption_perceptions_index']} 
						notes={countryAnswers.answerKeyValues['corruption_perceptions_index_notes']} 
						sourceRef={countryAnswers.answerKeyValues['corruption_perceptions_index_sources']} />
					</div>
					<div className="pull-right" style={{width: "48%"}}>
						<PopulationField defaultCountry={countryAnswers.answerKeyValues["country_code"]} heading={"Income Level "} 
						year={countryAnswers.answerKeyValues['income_level_year']} 
						value={countryAnswers.answerKeyValues['income_level']} 
						notes={countryAnswers.answerKeyValues['income_level_notes']} 
						sourceRef={countryAnswers.answerKeyValues['income_level_sources']} />
						<PopulationField defaultCountry={countryAnswers.answerKeyValues["country_code"]} heading={"Gross Domestic Product "} 
						year={countryAnswers.answerKeyValues['gdp_year']} 
						value={countryAnswers.answerKeyValues['gdp']} 
						notes={countryAnswers.answerKeyValues['gdp_notes']}  
						sourceRef={countryAnswers.answerKeyValues['gdp_sources']} />
						<PopulationField defaultCountry={countryAnswers.answerKeyValues["country_code"]} heading={"Inflation "} 
						year={countryAnswers.answerKeyValues['inflation_year']} 
						value={countryAnswers.answerKeyValues['inflation']} 
						notes={countryAnswers.answerKeyValues['inflation_notes']}  
						sourceRef={countryAnswers.answerKeyValues['inflation_sources']} />
					</div>
				</div>
			</div>);
}
export default Population;